import { render, staticRenderFns } from "./supplier-register.vue?vue&type=template&id=ece92c3e"
import script from "./supplier-register.vue?vue&type=script&lang=js"
export * from "./supplier-register.vue?vue&type=script&lang=js"
import style0 from "./supplier-register.vue?vue&type=style&index=0&id=ece92c3e&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/Resourced/Resourced/Frontend-old/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ece92c3e')) {
      api.createRecord('ece92c3e', component.options)
    } else {
      api.reload('ece92c3e', component.options)
    }
    module.hot.accept("./supplier-register.vue?vue&type=template&id=ece92c3e", function () {
      api.rerender('ece92c3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/pages/supplier-register.vue"
export default component.exports